module.exports = __webpack_public_path__ + "img/zoom-out.1f13815c.svg";